import React, { useCallback, useEffect, useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import api from "../../services/api.js";
import adicionar from "../../assets/icons8-mais-2-matemática-48.png";


import "react-toastify/dist/ReactToastify.css";
function Cadastro() {
  //  itens adm   COMEÇO
  const [values, setValues] = useState({});
  const [marcadores, setMarcadores] = useState([]);
  const [pages, setPages] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [mediaPage, setMediaPage] = useState(2);
  const [limit, setLimit] = useState(5);

  useEffect(() => {
    async function fetchData() {
      const { data } = await api.get("/ItemAdm", {
        headers: {
          typo: localStorage.getItem("id"),
        },
      });
      setMarcadores(data);
    }
    fetchData();
  }, []);

  useEffect(() => {
    async function fetchData() {
      const { data } = await api.get(`/ItemAdmPages?limit=${limit}&page=${currentPage}`, {
        headers: {
          typo: localStorage.getItem("id"),
        },
      });
      setMarcadores(data.manutencao.data);
    }
    fetchData();
  }, [currentPage, limit]);

  useEffect(() => {
    async function fetchData() {
      const { data } = await api.get("/totalItemAdm", {
        headers: {
          typo: localStorage.getItem("id"),
        },
      });

      let total = data.result;
      let totalPages = Math.ceil(total / limit);

      const arrayPages = [];
      for (let i = 1; i <= totalPages; i++) {
        arrayPages.push(i);
      }
      setPages(arrayPages);
    }
    fetchData();
  }, [limit]);

  const handlePagination = (page) => {
    setCurrentPage(page);
    if (page === 1) {
      setMediaPage(2);
    } else if (page === pages.length) {
      setMediaPage(page - 1);
    } else if (page > 0) {
      setMediaPage(page);
    }
  };

  const limits = useCallback((e) => {
    setLimit(e.target.value);
    setCurrentPage(1);
  }, []);

  const handleSubmitItensAdm = async (e) => {
    e.preventDefault();
    try {
      await api.post("/manutencaoItem", values);
      toast.success("item cadastrado com sucesso");
      setTimeout(() => {}, 1000);
      document.getElementById("myform").reset();
    } catch (error) {
      toast.error("Erro ao cadastrar novo item");
      console.log(error);
    }
  };

  const handleChangeItensAdm = (event) => {
    setValues((prevValues) => ({
      ...prevValues,
      [event.target.name]: event.target.value,
      id_cliente: localStorage.getItem("id"),
    }));
  };
  // Fim
  return (
    <>
      <h5 className="text-center">Administração</h5>
      <form className="row g-3 justify-content-center">
        <div className="col-md-5">
          <label className="form-label">Item</label>
          <input type="text" className="form-control" name="manutencao" onChange={(e) => handleChangeItensAdm(e)} />
        </div>
        <div className="col-md-1">
          <img src={adicionar} style={{ marginTop: "27px", marginLeft: "-15px" }} onClick={handleSubmitItensAdm} />
        </div>
      </form>
      <br></br>
      <div className="container">
        <div className="container text-center">
          <div className="row ">
            <div className="col rounded-top" style={{ background: "#304c7c", height: "55px" }}>
              <h4 style={{ marginTop: "10px" }} className="text-white ">
                Administração
              </h4>
            </div>
          </div>
        </div>
        <table className="table table table-bordered">
          <thead>
            <tr>
              <th scope="col">Item</th>
              <th scope="col"></th>
            </tr>
          </thead>
          <tbody>
            {marcadores.map((marcador, index) => (
              <tr>
                <td>{marcador.manutencao}</td>
                <td>Otto</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
}
export default Cadastro;
